import { render, staticRenderFns } from "./FormSent.vue?vue&type=template&id=7010be77&scoped=true"
var script = {}
import style0 from "./FormSent.vue?vue&type=style&index=0&id=7010be77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010be77",
  null
  
)

export default component.exports